module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bkC4e"))).then(() => parcelRequire('cvs7o'));